@if (isLoading) {
  <mds-loader></mds-loader>
}

@if (!isLoading && reload) {
  <article class="reload-container">
    <article class="reload-tile">
      <p>{{ errorMsg.message }}</p>
      @if (errorMsg.message.includes('reload')) {
        <mds-icon
          [key]="icons.RECYCLED"
          [width]="42"
          [height]="42"
          (click)="init()"
        ></mds-icon>
      }
      @if (errorMsg.message.includes('reload')) {
        <p>Please reload the page</p>
      }
    </article>
  </article>
}

@if (productInfo) {
  <div class="ecodesign">
    <div class="ecodesign__header">
      <p>Ecodesign analysis of</p>
      <h1>{{ productInfo.name }}</h1>
      <mds-chip
        [showChipIcon]="true"
        [icon]="icons.RELOAD"
        [label]="'Updated On ' + (productInfo.updated_on | ordinalDate)"
        [removable]="false"
        [theme]="'light'"
      ></mds-chip>
    </div>
    <article class="ecodesign__main">
      <section class="ecodesign__charts">
        @if (chart1Layer) {
          <div class="chart-container">
            <div class="chart-head-wrapper">
              <div>
                <h3 [matTooltip]="chart1Layer.title" matTooltipHideDelay="300">{{ chart1Layer.title }}</h3>
                <p>{{ chart1Layer.subtext }}</p>
              </div>
              <mds-dropdown-menu
                [minWidth]="'100px'"
                [showArrows]="true"
                [helperTextPre]="'Category'"
                [text]="chartDropDown[0].text"
                [options]="chartDropDown"
                (selectedValueChange)="onChartChange($event, 'chart1')"
              ></mds-dropdown-menu>
            </div>
            <div class="chart-wrapper">
              <highcharts-chart
                [Highcharts]="Highcharts" [options]="Chart1Options"
                                [callbackFunction]="chartCallback1"></highcharts-chart>
            </div>

          </div>
        }
        @if (chart2Layer) {
          <div class="chart-container" >
            <div class="chart-head-wrapper">
              <div>
                <h3 [matTooltip]="chart2Layer.title" matTooltipShowDelay="300">{{ chart2Layer.title }}</h3>
                <p>{{ chart2Layer.subtext }}</p>
              </div>
              <mds-dropdown-menu
                [minWidth]="'100px'"
                [showArrows]="true"
                [helperTextPre]="'Category'"
                [text]="chartDropDown[1].text"
                [options]="chartDropDown"
                (selectedValueChange)="onChartChange($event, 'chart2')"
              ></mds-dropdown-menu>
            </div>
            <div class="chart-wrapper">
            <highcharts-chart
              [Highcharts]="Highcharts" [options]="Chart2Options"
                              [callbackFunction]="chartCallback2"></highcharts-chart>
            </div>
          </div>
        }
      </section>
      <section class="ecodesign__grid">
        <mds-grid
          [overrides]="overrides"
          [minHeight]="'100%'"
          [themeClass]="'ag-theme-material'"
          (gridReady)="onGridReady($event)"
          [sizeColumnsToFit]="true"
        ></mds-grid>
      </section>
    </article>
  </div>
}
